import React from 'react';
//import PropTypes from 'prop-types';
import ParallaxElement from '../common/ParallaxElement';

export default class NinjaGirl extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <ParallaxElement yStrength={0.1} stopY={-560} id="ninja">
                <div id="ninjaWrapper" className="ninjaGirlWrapper" />
            </ParallaxElement>
        );
    }
}

